import React from "react";

export default function SuspendedPage() {
  return (
    <div
      className="min-h-screen bg-black text-white flex items-center justify-center px-6"
      data-testid="site-suspended-page"
    >
      <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-center tracking-tight">
        Titan Car Rentals is Temporarily offline.
      </h1>
    </div>
  );
}
